// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as React from "react";
import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as DialogForm from "../../components/DialogForm/DialogForm.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as ReactIntl from "react-intl";
import * as InputDonors from "../../components/InputDonors/InputDonors.bs.jsx";
import * as InputToggle from "../../components/InputToggle/InputToggle.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as FormattedCurrency from "../../components/FormattedCurrency/FormattedCurrency.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import KegAddNewModuleCss from "./KegAddNew.module.css";

let classes = KegAddNewModuleCss;

function get(state, field) {
  switch (field) {
    case "Beer" :
      return state.beer;
    case "Donors" :
      return state.donors;
    case "Milliliters" :
      return state.milliliters;
    case "OwnerIsDonor" :
      return state.ownerIsDonor;
    case "Price" :
      return state.price;
    case "Serial" :
      return state.serial;
  }
}

function set(state, field, value) {
  switch (field) {
    case "Beer" :
      return {
        beer: value,
        donors: state.donors,
        milliliters: state.milliliters,
        ownerIsDonor: state.ownerIsDonor,
        price: state.price,
        serial: state.serial
      };
    case "Donors" :
      return {
        beer: state.beer,
        donors: value,
        milliliters: state.milliliters,
        ownerIsDonor: state.ownerIsDonor,
        price: state.price,
        serial: state.serial
      };
    case "Milliliters" :
      return {
        beer: state.beer,
        donors: state.donors,
        milliliters: value,
        ownerIsDonor: state.ownerIsDonor,
        price: state.price,
        serial: state.serial
      };
    case "OwnerIsDonor" :
      return {
        beer: state.beer,
        donors: state.donors,
        milliliters: state.milliliters,
        ownerIsDonor: value,
        price: state.price,
        serial: state.serial
      };
    case "Price" :
      return {
        beer: state.beer,
        donors: state.donors,
        milliliters: state.milliliters,
        ownerIsDonor: state.ownerIsDonor,
        price: value,
        serial: state.serial
      };
    case "Serial" :
      return {
        beer: state.beer,
        donors: state.donors,
        milliliters: state.milliliters,
        ownerIsDonor: state.ownerIsDonor,
        price: state.price,
        serial: value
      };
  }
}

let FormFields = {
  get: get,
  set: set
};

let emptyState_donors = {};

let emptyState = {
  beer: "",
  donors: emptyState_donors,
  milliliters: 0,
  ownerIsDonor: true,
  price: 0,
  serial: 1
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

let getSelectedOption = (select => Array.from(select.selectedOptions, option => option.value));

function KegAddNew$FormComponent(props) {
  let personsAll = props.personsAll;
  let onSubmit = props.onSubmit;
  let personsAllMap = React.useMemo(() => new Map(personsAll.map(param => [
    param[0],
    param[1].name
  ])), [personsAll]);
  let match = FormattedCurrency.useCurrency();
  let minorUnit = match.minorUnit;
  let currency = match.currency;
  let mostRecentKegStatus = Db.useMostRecentKegStatus(props.placeId);
  let mostResentKegs = mostRecentKegStatus.data;
  if (mostResentKegs === undefined) {
    return null;
  }
  let recentKegState = Stdlib_Option.mapOr(mostResentKegs.at(0), emptyState, keg => ({
    beer: keg.beer,
    donors: keg.donors,
    milliliters: keg.milliliters,
    ownerIsDonor: true,
    price: keg.price,
    serial: keg.serial + 1 | 0
  }));
  let form = Form.use(recentKegState, Validators$1.schema([
    Validators$1.required("Beer"),
    Validators$1.int(1, "Sud nemůže být nulový", undefined, undefined, "Milliliters"),
    Validators$1.int(0, "Cena nemůže být záporná", undefined, undefined, "Price"),
    Validators$1.custom(lensState => {
      if (lensState.ownerIsDonor) {
        return "Valid";
      }
      let donorsSum = Stdlib_Array.reduce(Object.values(lensState.donors), 0, (a, b) => a + b | 0);
      let kegPrice = lensState.price;
      if (kegPrice > 0 && kegPrice !== donorsSum) {
        return {
          TAG: "Error",
          _0: "Cena sudu se neshoduje s příspěvky vkladatelů"
        };
      } else {
        return "Valid";
      }
    }, "Donors")
  ]), param => {
    onSubmit(param.state.values);
  }, undefined, undefined, "OnDemand", undefined);
  return <Form.Provider.make
    value={form}
  >
    <form
      className={classes.form}
      id={"add_keg"}
      onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
    >
      <fieldset
        className={`reset ` + Styles.fieldset.grid}
      >
        <Form.Field.make
          field={"Beer"}
          render={field => <InputWrapper.make
            inputError={field.error}
            inputName={"beer"}
            inputSlot={<input
              type={"text"}
              value={field.value}
              onChange={ReForm__Helpers.handleChange(field.handleChange)}
            />}
            labelSlot={"Pivo"}
          />}
        />
        <Form.Field.make
          field={"Milliliters"}
          render={field => {
            let liters = field.value / 1000.0;
            return <InputWrapper.make
              inputError={field.error}
              inputName={"milliliters"}
              inputSlot={<input
                max={"200"}
                min={"1"}
                step={1.0}
                type={"number"}
                value={liters.toString()}
                onChange={event => field.handleChange(event.target.valueAsNumber * 1000 | 0)}
              />}
              labelSlot={"Objem sudu"}
              unitSlot={<ReactIntl.FormattedPlural
                value={liters | 0}
                other={"Litrů"}
                one={"Litr"}
                few={"Litry"}
              />}
            />;
          }}
        />
        <Form.Field.make
          field={"Price"}
          render={field => <InputWrapper.make
            inputError={field.error}
            inputName={"price"}
            inputSlot={<input
              min={"0"}
              step={1.0}
              type={"number"}
              value={(field.value / minorUnit).toString()}
              onChange={event => field.handleChange(event.target.valueAsNumber * minorUnit | 0)}
            />}
            labelSlot={"Cena sudu"}
            unitSlot={<ReactIntl.FormattedNumberParts
              value={0}
              style={"currency"}
              currency={currency}
            >
              {formattedNumberParts => Stdlib_Option.getOr(Stdlib_Option.map(formattedNumberParts.find(p => p.type === `currency`), p => p.value), null)}
            </ReactIntl.FormattedNumberParts>}
          />}
        />
      </fieldset>
      <Form.Field.make
        field={"OwnerIsDonor"}
        render={field => {
          let ownerIsDonor = field.value;
          return <>
            <InputWrapper.make
              inputName={"owner_is_donor"}
              inputSlot={<InputToggle.make
                checked={ownerIsDonor}
                onChange={event => {
                  let target = event.target;
                  field.handleChange(target.checked);
                }}
              />}
              labelSlot={"Vkládá vlastník místa"}
            />
            {ownerIsDonor ? null : <Form.Field.make
                field={"Donors"}
                render={field => <InputDonors.make
                  errorMessage={field.error}
                  legendSlot={"Vkladatelé sudu"}
                  persons={personsAllMap}
                  value={field.value}
                  onChange={field.handleChange}
                />}
              />}
          </>;
        }}
      />
    </form>
  </Form.Provider.make>;
}

let FormComponent = {
  make: KegAddNew$FormComponent
};

function KegAddNew(props) {
  return <DialogForm.make
    formId={"add_keg"}
    heading={"Přidat sud"}
    onDismiss={props.onDismiss}
    visible={true}
  >
    <React.Suspense
      fallback={"Načítám"}
    >
      {<FormComponent.make
        onSubmit={props.onSubmit}
        personsAll={props.personsAll}
        placeId={props.placeId}
      />}
    </React.Suspense>
  </DialogForm.make>;
}

let make = KegAddNew;

export {
  classes,
  FormFields,
  emptyState,
  Form,
  Validators$1 as Validators,
  getSelectedOption,
  FormComponent,
  make,
}
/* classes Not a pure module */
